const getApiHost = (fallback = process.env.REACT_APP_API_HOST) => {
  const { hostname, protocol: _protocol } = window.location;

  if (hostname === 'localhost') {
    return fallback;
  }
  if (hostname === 'signals-demo.nitro.run') {
    return 'https://signals-demo-v3.api.nitro.run';
  }
  // c8 ignore next 4
  if (
    hostname === 'signals-demo-prod.nitro.run' ||
    hostname === 'nitro-claw.orbits.run'
  ) {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'agenttrigger.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'signals-demo.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'ai-analyst.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'akshat.orbits.run') {
    return 'https://success.api.rocketlane.com';
  }
  if (hostname === 'chargebee-signals-demo.nitro.run') {
    return 'https://ps-chargebee.api.rocketlane.com';
  }
  if (hostname === 'tipalti-signals-demo.nitro.run') {
    return 'https://tipalti.api.rocketlane.com';
  }
  if (
    hostname === 'tsia-demo.nitro.run' ||
    hostname === 'tsia-demo.rocketlane.com'
  ) {
    return 'https://tsia-demo.api.rocketlane.com';
  }
  if (hostname === 'salesforce-v2.orbits.run') {
    return 'https://sf-autofetch-contacts.api.orbits.run';
  }
  if (
    hostname === 'scarlet-mod-eu.rocketlane.com' ||
    hostname === 'agents-eu.rocketlane.com'
  ) {
    return 'https://api.eu.rocketlane.com';
  }

  const domainArr = hostname.split('.');
  const _subdomain = domainArr[0];

  return hostname.replace(_subdomain, `${_protocol}//${_subdomain}.api`);
};

const getApiNamespace = () => {
  const { hostname } = window.location;

  if (hostname === 'salesforce-v2.orbits.run') {
    return 'api';
  }

  return 'scarlet_api';
};

export const API_HOST = getApiHost('');
export const API_VERSION = 'v1';
export const API_NAMESPACE = getApiNamespace();
/**
 * Read clientRegion from the host's accountMeta. When this app is embedded
 * inside rocket-frontend via Module Federation, the host has populated
 * accountMeta in localStorage via getInitData(). Returns undefined when
 * running standalone or before accountMeta has loaded.
 */
const getClientRegionFromMeta = (): string | undefined => {
  try {
    const accountMetaStr = localStorage.getItem('accountMeta');

    if (accountMetaStr) {
      const accountMeta = JSON.parse(accountMetaStr);

      return accountMeta?.clientRegion;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(
      '[getClientRegionFromMeta] Failed to parse accountMeta:',
      error,
    );
  }

  return undefined;
};

const getTiptapCollabBaseUrl = () => {
  const { hostname } = window.location;

  if (
    getClientRegionFromMeta() === 'eu' ||
    hostname === 'scarlet-mod-eu.rocketlane.com' ||
    hostname === 'agents-eu.rocketlane.com'
  ) {
    return 'https://tiptap-collab.api.eu.rocketlane.com';
  }

  return (
    process.env.TIPTAP_COLLAB_BASE_URL ||
    'https://tiptap-collab.api.rocketlane.com'
  );
};

const getApiHostAgents = () => {
  const { hostname } = window.location;

  if (
    getClientRegionFromMeta() === 'eu' ||
    hostname === 'scarlet-mod-eu.rocketlane.com' ||
    hostname === 'agents-eu.rocketlane.com'
  ) {
    return 'https://conversation-service.rl-platforms-eu.rocketlane.com';
  }

  return 'https://conversation-service.rl-platforms.rocketlane.com';
};

export const API_HOST_AGENTS = getApiHostAgents();
export const AG_GRID_LICENSE_KEY =
  process.env.REACT_APP_AG_GRID_LICENSE_KEY || '';
export const TIPTAP_COLLAB_BASE_URL = getTiptapCollabBaseUrl();
export const TIPTAP_CONVERTER_APP_ID =
  process.env.TIPTAP_CONVERTER_APP_ID || '';
export const TIPTAP_CONVERTER_ENDPOINT =
  process.env.TIPTAP_CONVERTER_ENDPOINT || '';
